if (!customElements.get('adev-cart-drawer')) {
    customElements.define('adev-cart-drawer', class adevCartDrawer extends HTMLElement {
        constructor() {
            super();
        }

        initCartLinks() {
            document.querySelectorAll('[data-adev-cart-link]').forEach((link) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.open();
                });
            });
        }

        refreshUpsell() {
            const upsellEl = this.querySelector('adev-cart-drawer-upsell');
            if (upsellEl) {
                upsellEl.refresh();
            }
        }

        isOpened() {
            return this.classList.contains('is--active');
        }

        open() {
            this.classList.add('is--active');
            document.dispatchEvent(new CustomEvent('adev:open-overlay', { bubbles: true }));
            this.refreshUpsell();
        }

        close() {
            this.classList.remove('is--active');
            document.dispatchEvent(new CustomEvent('adev:close-overlay', { bubbles: true }));
        }

        loadingState(state = true) {
            if (state) {
                this.classList.add('is--loading');
                return;
            }

            this.classList.remove('is--loading');
        }

        initCloseButton() {
            const closeButton = this.querySelector('[data-adev-cart-drawer="close"]');
            if (!closeButton) return;

            closeButton.addEventListener('click', this.close.bind(this));
        }

        setupEvents() {
            document.addEventListener('adev:cart-drawer:refresh', this.refreshWithData.bind(this));

            document.addEventListener('adev:cart-drawer:loading', (e) => {
                this.loadingState(e.detail);
            });

            document.addEventListener('adev:overlay-click', this.close.bind(this));

            document.addEventListener('adev:open-cart-drawer', this.open.bind(this));
            document.addEventListener('adev:close-cart-drawer', this.close.bind(this));
        }

        initQuantityChange() {
            this.querySelectorAll('adev-quantity-selector').forEach((quantitySelector) => {
                quantitySelector.addEventListener('adev:quantity:changed', window.adev.Utils.debounce((newQuantity) => {
                    this.submitForm();
                }, 400));
            });
        }

        refreshWithData(event) {
            this.renderContents(event.detail);
        }

        renderContents(sections) {
            const domParserInstance = new DOMParser();

            if (sections.hasOwnProperty('adev-cart-drawer')) {
                const parsedCartDrawer = domParserInstance.parseFromString(sections['adev-cart-drawer'], 'text/html');
                const newCartDrawerContents = parsedCartDrawer.querySelector('[data-adev-cart-drawer="form"]');

                const contentsEl = this.querySelector('[data-adev-cart-drawer="form"]');
                if (contentsEl) contentsEl.innerHTML = newCartDrawerContents.innerHTML;
            }

            if (sections.hasOwnProperty('cart-icon-bubble')) {
                const parsedCartIcon = domParserInstance.parseFromString(sections['cart-icon-bubble'], 'text/html');
                const newCartIcon = parsedCartIcon.querySelector('#shopify-section-cart-icon-bubble');
                const cartIconEl = document.querySelector('#cart-icon-bubble');
                if (cartIconEl) cartIconEl.innerHTML = newCartIcon.innerHTML;
            }

            document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: false }));

            this.initQuantityChange();
            this.initCloseButton();
            this.refreshUpsell();
        }

        submitForm() {
            document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: true }));
            
            const formEl = this.querySelector('[data-adev-cart-drawer="form"]');

            const formData = new FormData(formEl);
            formData.append('sections', 'adev-cart-drawer,cart-icon-bubble');
			formData.append('sections_url', window.location.pathname);

            fetch(theme.routes.cartUpdateUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:refresh', { detail: data.sections }));
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: false }));
            });
        }

        init(){
            this.initCartLinks();
            this.setupEvents();
            this.initQuantityChange();
            this.initCloseButton();
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            
        }

    });
}

if (!customElements.get('adev-remove-cart-item')) {
    customElements.define('adev-remove-cart-item', class adevRemoveCartItem extends HTMLElement {
        constructor() {
            super();
        }

        _removeItem(e) {
            e.preventDefault();
            
            const key = this.getAttribute('data-key');
            if (!key) return;

            document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: true }));

            const formData = new FormData();
            formData.append('id', key);
            formData.append('quantity', 0);
            formData.append('sections', 'adev-cart-drawer,cart-icon-bubble');

            fetch(theme.routes.cartChangeUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:refresh', { detail: data.sections }));
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                document.dispatchEvent(new CustomEvent('adev:cart-drawer:loading', { detail: false }));
            });
        }

        connectedCallback() {
			if (this.hasAttribute('data-adev-remove-cart-item')) {
                this.addEventListener('click', this._removeItem.bind(this));
            } else {
                this.querySelectorAll('[data-adev-remove-cart-item]').forEach((btn) => {
                    btn.addEventListener('click', this._removeItem.bind(this));
                });
            }
        }

        disconnectedCallback() {
            if (this.hasAttribute('data-adev-remove-cart-item')) {
                this.removeEventListener('click', this._removeItem.bind(this));
            } else {
                this.querySelectorAll('[data-adev-remove-cart-item]').forEach((btn) => {
                    btn.removeEventListener('click', this._removeItem.bind(this));
                });
            }
        }

    });
}

if (!customElements.get('adev-cart-drawer-upsell')) {
    customElements.define('adev-cart-drawer-upsell', class adevCartDrawerUpsell extends HTMLElement {
        constructor() {
            super();
            
            this.carouselEl = this.querySelector('[data-adev-cart-drawer-upsell="carousel"]');
            this.prevButtonEl = this.querySelector('[data-adev-cart-drawer-upsell="nav-prev"]');
            this.nextButtonEl = this.querySelector('[data-adev-cart-drawer-upsell="nav-next"]');
            this.navTextEl = this.querySelector('[data-adev-cart-drawer-upsell="nav-text"]');

            this.addEventListener('adev:refresh', this.refresh.bind(this));

            // this.dispatchEvent(new CustomEvent('adev:refresh'));
        }

        refresh() {
            if (!this.carouselInstance) return;

            this.carouselInstance.reloadCells();
            this.carouselInstance.resize();
            this.carouselInstance.select(0);
        }
        
        getCellAlign() {
            return 'left';
        }

        getInitialIndex () {
            return 0;
        }
        
        initCarousel(){
            if (!this.carouselEl) return;

            let settings = {
                cellAlign: this.getCellAlign(),
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: this.getInitialIndex(),
                adaptiveHeight: true,
                on: {
                    ready: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                    },
                    settle: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    dragStart: () => {
                        this.carouselEl.classList.add('adev--flickity-moving');
                    },
                    dragEnd: () => {
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    change: () => {
                        this.updateNavText();
                    },
                    select: () => {
                        this.updateNavText();
                    }
                }
            };

            this.carouselInstance = new Flickity(this.carouselEl, settings);

            this.initArrows();
        }

        initArrows() {
            if (this.prevButtonEl) {
                this.prevButtonEl.addEventListener('click', this.goPrev.bind(this));
            }

            if (this.nextButtonEl) {
                this.nextButtonEl.addEventListener('click', this.goNext.bind(this));
            }
        }

        goPrev(){
            if(this.carouselInstance){
                this.carouselInstance.previous();
            }
        }

        goNext(){
            if(this.carouselInstance){
                this.carouselInstance.next();
            }
        }

        updateNavText() {
            if (!this.navTextEl || !this.carouselInstance) return;

            const currentIndex = this.carouselInstance.selectedIndex;
            const slideCount = this.carouselInstance.slides.length;

            this.navTextEl.textContent = `${currentIndex + 1} / ${slideCount}`;
        }

        destroyCarousel() {
            if (this.carouselInstance) {
                this.carouselInstance.destroy();
                this.carouselInstance = null;
            }

            if (this.prevButtonEl) {
                this.prevButtonEl.removeEventListener('click', this.goPrev.bind(this));
            }

            if (this.nextButtonEl) {
                this.nextButtonEl.removeEventListener('click', this.goNext.bind(this));
            }
        }

        connectedCallback() {
            this.initCarousel();
        }

        disconnectedCallback() {
            this.destroyCarousel();
        }

    });
}

if (!customElements.get('adev-cart-drawer-upsell-item')) {
    customElements.define('adev-cart-drawer-upsell-item', class adevCartDrawerUpsellItem extends HTMLElement {
        constructor() {
            super();

            this.variants = [];
            this.currentVariant = {};
        }

        initVariantSelector() {
            const variantEl = this.querySelector('[data-adev-cart-drawer-upsell-item="variant-select"]');
            if (!variantEl) return;

            variantEl.addEventListener('change', this.onVariantChange.bind(this));
        }

        setCurrentVariant() {
            const variantEl = this.querySelector('[data-adev-cart-drawer-upsell-item="variant-select"]');
            
            if (!variantEl) return;

            const selectedVariantId = variantEl.value;
            this.currentVariant = this.variants.find(variant => variant.id === parseInt(selectedVariantId));
        }

        updateImage() {
            const imageEl = this.querySelector('[data-adev-cart-drawer-upsell-item="image"]');
            if (!imageEl) return;
        }

        updatePrices() {
            const pricesEl = this.querySelector('[data-adev-cart-drawer-upsell-item="prices"]');
            if (!pricesEl) return;
            
            const compareAtPriceEl = this.querySelector('[data-adev-cart-drawer-upsell-item="compare-at-price"]');
            const priceEl = this.querySelector('[data-adev-cart-drawer-upsell-item="price"]');

            const compareAtPrice = this.currentVariant.compare_at_price;
            const price = this.currentVariant.price;

            const onSale = compareAtPrice > price;

            pricesEl.setAttribute('data-on-sale', onSale);

            if (onSale) {
                const strikeEl = document.createElement('s');
                strikeEl.textContent = Shopify.formatMoney(compareAtPrice);
                compareAtPriceEl.innerHTML = '';
                compareAtPriceEl.appendChild(strikeEl);
            } else {
                compareAtPriceEl.innerHTML = '';
            }

            priceEl.innerHTML = Shopify.formatMoney(price);
        }

        updateAddToCartButton() {
            const atcButton = this.querySelector('[data-adev-cart-drawer-upsell-item="add-to-cart"]');
            if (!atcButton) return;

            atcButton.disabled = !this.currentVariant.available;
        }

        onVariantChange() {
            this.setCurrentVariant();
            this.updateImage();
            this.updatePrices();
            this.updateAddToCartButton();
        }

        initForm() {
            const atcButton = this.querySelector('[data-adev-cart-drawer-upsell-item="add-to-cart"]');
            if (!atcButton) return;

            atcButton.addEventListener('click', this.onAddToCartClick.bind(this));
        }

        onAddToCartClick() {
            const atcButton = this.querySelector('[data-adev-cart-drawer-upsell-item="add-to-cart"]');

            atcButton.classList.add('is--loading');

            const formData = new FormData();
            formData.append('id', this.currentVariant.id);
            formData.append('quantity', 1);
            formData.append('sections', 'adev-cart-drawer,cart-icon-bubble');

            fetch( theme.routes.cartAddUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                if (data.message) {
                    alert(data.message);
                    atcButton.classList.remove('is--loading');
                    return;
                }

                document.dispatchEvent(new CustomEvent('adev:cart-drawer:refresh', { detail: data.sections }));
                
                atcButton.classList.remove('is--loading');
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                atcButton.classList.remove('is--loading');
            });
        }

        loadData() {
            const jsonData = this.querySelector('[data-adev-cart-drawer-upsell-item="product-json"]');
            if (!jsonData) return;

            this.variants = JSON.parse(jsonData.innerHTML);
        }

        init(){
            this.loadData();
            this.setCurrentVariant();
            this.initVariantSelector();
            this.initForm();
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            
        }

    });
}